/* eslint-disable */
// @ts-nocheck

/*
 * Copied from the function 'setuptextFilter' in the bynder-platform JS file:
 *      bynder/includes/js/bynder/search/filterhelper.js
 *
 * Only the part of the function relevant to sticky-search is copied over.
 */

export function initStickySearch() {
	const bynder = window.bynder;

	var searchParams = bynder?.search?.FilterHelper?.getSearchParams?.();

	const url = new URL(window.location.href);
	const params = url.searchParams;
	const similarityToTextParam = params.get('similarToText');

	if (similarityToTextParam) {
		url.searchParams.delete('similarToText');
		history.replaceState(null, '', url);
		return similarityToTextParam;
	}

	if (searchParams?.singletext !== null && searchParams?.singletext !== undefined) {
		_appendTextFilter('singletext', searchParams.singletext);
		return searchParams.singletext;
	}

	return '';
}

// This function can be removed once the active filters bar migration rollout is complete
// I'm adding the Split id here so that we remember to do it when we clean it up: assetbank_new_active_filterbar
// This private function is copied from bynder-platfor as it is used by initStickySearch
function _appendTextFilter(type, text) {
	const bynder = window.bynder;

	bynder.search.FilterBar.add(
		'',
		type,
		text,
		text,
		function (e) {
			var filterText = e.data.text;
			bynder.search.FilterBar.remove(type, filterText);
			bynder.search.FilterHelper.search(
				'media',
				{
					field: type,
					value: filterText,
					filterType: 'remove',
				},
				function () {
					var $scoreOrderByBtn = document.querySelector(
						'a[data-type="orderBy"][data-value="score"]',
					)?.parentNode;
					if (
						$scoreOrderByBtn &&
						($scoreOrderByBtn as HTMLElement).classList.contains('active')
					) {
						const parentNode = $scoreOrderByBtn.parentNode;
						if (parentNode) {
							const anchor = parentNode.querySelector('a[data-default="true"]');
							if (anchor) {
								(anchor as HTMLElement).click();
							}
						}
					}
					if ($scoreOrderByBtn) {
						($scoreOrderByBtn as HTMLElement).remove();
					}
				},
			);
		},
		true,
	);
}
